import { AuthAndEligibilityHistoryPayload, DisciplinePayload } from "../models/Authorization";
import { GetQueryString } from "../utils";
import API from "./api";

export const GetAuthHistory = (configUrl: string, payload: AuthAndEligibilityHistoryPayload) => {
  return API.post(`${configUrl}api/ReferralService/AuthorizationHistory`, payload);
};

export const GetDisciplines = (
  configUrl: string,
  payload: DisciplinePayload
) => {
  return API.get(
    `${configUrl}api/authorization/DisciplineList?${GetQueryString(payload)}`
  );
};

export const GetDisciplineDetails = (
  configUrl: string, serviceRequestDisciplineId: number ) =>API.get(
      `${configUrl}api/authorization/HpPortalDiscipline/${serviceRequestDisciplineId}`
    );
